import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import staff from './modules/staff'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    staff
  },
  getters
})

export default store
